// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__DqcYN","errorLogs":"EditorFooter_errorLogs__1Gz9f"};